import React from 'react';
import { ChannelProfileImage } from '../../../../components';
import { useChannelName } from '../../../../../Slice';
import { ImageCreateChannel } from '../../../../rootAccess';
import PropTypes from 'prop-types';

const ChannelProfile = ({ channelId }) => {
   const channelName = useChannelName(channelId);

   /** const getChannelAvatar = channelName => {
      const initials =
         channelName
            ?.split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2) || 'CH';

      return initials;
   }; */

   const getChannelColor = channelName => {
      const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F'];
      const index = channelName?.length % colors.length || 0;
      return colors[index];
   };

   return (
      <div className="channel-avatar" style={{ backgroundColor: getChannelColor(channelName) }}>
         <ChannelProfileImage
            channelId={channelId}
            defaultImg={ImageCreateChannel}
            className="channel-avatar"
            alt={'Channel Image'}
         />
         {/* <span className="avatar-text">{getChannelAvatar(channelName)}</span> */}
      </div>
   );
};

export const ChannelAvatar = React.memo(ChannelProfile);

ChannelProfile.propTypes = {
   channelId: PropTypes.string.isRequired,
};
